import type { MenuItems } from "./menu.type";

import { useLocation } from "react-router";

import { useStaticRouteLink } from "@/modules/static-route";

import { getMenuItemsSelectedKeys } from "./menu.helper";

export const useMenuSelectedKeys = (menuItems: MenuItems) => {
  const { pathname, search } = useLocation();
  const homePathname = useStaticRouteLink("dashboard");

  return {
    selectedKeys: getMenuItemsSelectedKeys({
      menuItems,
      pathname,
      search,
      homePathname,
    }),
  };
};
